'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Device = require('./Device');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Device).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Device/index.js
// module id = 1169
// module chunks = 1